import { Button, Label, Position, Tooltip } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { DivLineWithButtonMargin } from '../../styledComponents/StyledComponents';
import React from 'react';
import { Translate } from '../../WithTranslate';
import { TLCode } from '../../../../common/enums';
import TranslatedMessage from '../../translation/TranslatedMessage';

interface YearNavigationProps {
  translate: Translate;
  yearSelected: number | undefined;
  nextYear: () => void;
  previousYear: () => void;
  onS1Clicked?: () => void;
  onS2Clicked?: () => void;
}

export const YearNavigation = ({
  translate,
  previousYear,
  nextYear,
  yearSelected,
  onS1Clicked,
  onS2Clicked,
}: YearNavigationProps) => {
  return (
    <DivLineWithButtonMargin>
      <Tooltip
        content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_PreviousYear)}
        position={Position.BOTTOM}
        hoverOpenDelay={750}
      >
        <Button
          icon={IconNames.CHEVRON_LEFT}
          large={true}
          style={{ height: '30px', marginLeft: '5px' }}
          onClick={previousYear}
        />
      </Tooltip>
      <Label
        style={{
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '25px',
          verticalAlign: 'center',
        }}
      >
        {yearSelected}
      </Label>
      <Tooltip
        content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_NextYear)}
        position={Position.BOTTOM}
        hoverOpenDelay={750}
      >
        <Button
          icon={IconNames.CHEVRON_RIGHT}
          large={true}
          style={{ height: '30px', marginLeft: '5px' }}
          onClick={nextYear}
        />
      </Tooltip>
      {onS1Clicked && onS2Clicked && (
        <>
          <Tooltip
            content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_S1)}
            position={Position.BOTTOM}
            hoverOpenDelay={750}
          >
            <Button large={true} style={{ height: '30px', marginLeft: '10px' }} onClick={onS1Clicked}>
              <TranslatedMessage id={TLCode.ROSTER_S1} />
            </Button>
          </Tooltip>
          <Tooltip
            content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_S2)}
            position={Position.BOTTOM}
            hoverOpenDelay={750}
          >
            <Button large={true} style={{ height: '30px', marginLeft: '10px' }} onClick={onS2Clicked}>
              <TranslatedMessage id={TLCode.ROSTER_S2} />
            </Button>
          </Tooltip>
        </>
      )}
    </DivLineWithButtonMargin>
  );
};
